module.exports = __webpack_public_path__ + "img/phone-call.07ed6a4c.svg";